<template>
  <div>
    <el-drawer v-model="model" :size="anchoSidebar"
      header-class="bg-primary text-white py-1 d-flex justify-content-center" :close-on-click-modal="false">
      <template #header>
        <section>
          <h3 class="text-white">Invitar Colaborador</h3>
        </section>
      </template>

      <b-form @submit.prevent="enviar()">
        <section class="formulario">
          <b-form-group>
            <template #label>
              <b>Nombre: <span class="text-danger">*</span></b>
            </template>

            <b-form-input v-model="nombre" v-bind="nombre_attrs" placeholder="Nombre del Colaborador" size="sm"
              :state="!errors.nombre" />
            <b-form-invalid-feedback :state="!errors.nombre">
              {{ errors.nombre }}
            </b-form-invalid-feedback>

          </b-form-group>

          <b-form-group>
            <template #label>
              <b>Email: <span class="text-danger">*</span></b>
            </template>

            <b-form-input v-model="email" v-bind="email_attrs" placeholder="Email del Colaborador" size="sm"
              :state="!errors.email" />
            <b-form-invalid-feedback :state="!errors.email">
              {{ errors.email }}
            </b-form-invalid-feedback>
          </b-form-group>

          <b-form-group>
            <template #label>
              <b>Mensaje: <span class="text-danger">*</span></b>
            </template>

            <b-form-textarea v-model="mensaje" v-bind="mensaje_attrs" placeholder="Mensaje para el Colaborador"
              size="sm" :state="!errors.mensaje" />
            <b-form-invalid-feedback :state="!errors.mensaje">
              {{ errors.mensaje }}
            </b-form-invalid-feedback>
          </b-form-group>



        </section>

        <footer class="mt-1">
          <b-button-group>
            <b-button type="submit" title="Enviar Invitación" v-loading="loading" :disabled="loading">
              <font-awesome-icon icon="fas fa-paper-plane" />
              Enviar Invitación
            </b-button>
          </b-button-group>
        </footer>
      </b-form>
    </el-drawer>
  </div>
</template>

<script setup>
import useAppStore from '@/store/app';

import { useForm } from 'vee-validate';
import { required, email as em, min } from '@validations';
import useUsuarioStore from '@/store/usuario';

import useRootStore from '@/store/root';

const root_store = useRootStore();
const { loading } = storeToRefs(root_store);
const model = defineModel({
  type: Boolean,
  default: false
});

const props = defineProps({

  titulo: {
    type: String,
    default: ''
  },

  configuracionId: {
    type: [Number, String],
  }
});

const emits = defineEmits(['invitacion-enviada']);

const app_store = useAppStore();
const { anchoSidebar } = storeToRefs(app_store);
const usuario_store = useUsuarioStore();

const { configuracionId } = toRefs(props);

const { defineField, handleSubmit, setErrors, errors, resetForm } = useForm({

  initialValues: {
    nombre: '',
    email: '',
    mensaje: ''
  },

  validationSchema: {
    nombre: required,
    email: [required, em],
    mensaje: [required, (val, ctx) => min(val, 10, ctx)]
  }

});

const [nombre, nombre_attrs] = defineField('nombre', { type: String });
const [email, email_attrs] = defineField('email', { type: String });
const [mensaje, mensaje_attrs] = defineField('mensaje', { type: String });

const enviar = handleSubmit((values) => {

  preguntar({
    title: '¿Está seguro de enviar la invitación?',
    text: 'Una vez enviada no podrá editar la invitación',
  }, () => {
    usuario_store.enviarInvitacion({
      ...values,
      configuracion_id: configuracionId.value,
      titulo: props.titulo
    }).then(({ result, invitacion: inv }) => {
      if (result) {
        toast.success("La invitación fue enviada correctamente");
        resetForm();
        emits('invitacion-enviada', inv);
      } else {
        toast.error("Error al enviar la invitación");
      }
    }).catch(e => {
      if (e.response.status === 422) {
        setErrors(e.response.data.errors);
      } else {
        toast.error("Error al enviar la invitación");
      }
    });
  })
});

</script>

<style lang="scss" scoped>
:deep(.formulario) {
  display: flex;
  flex-wrap: wrap;

  .b-form-group:has(> input) {
    flex: 1 1 250px;
    margin: 0.5rem;
  }

  .b-form-group:has(> textarea) {
    flex: 1 0 95%;
    margin: 0.5rem;
  }

}
</style>